import { render, staticRenderFns } from "./NoOrder.vue?vue&type=template&id=a8865d9e&scoped=true"
import script from "./NoOrder.vue?vue&type=script&lang=js"
export * from "./NoOrder.vue?vue&type=script&lang=js"
import style0 from "./NoOrder.vue?vue&type=style&index=0&id=a8865d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8865d9e",
  null
  
)

export default component.exports